/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Code_FailedInputs */

const en_password_reset_code_failed = /** @type {(inputs: Password_Reset_Code_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password reset failed`)
};

const es_password_reset_code_failed = /** @type {(inputs: Password_Reset_Code_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al restablecer la contraseña`)
};

/**
* | output |
* | --- |
* | "Password reset failed" |
*
* @param {Password_Reset_Code_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_code_failed = /** @type {((inputs?: Password_Reset_Code_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Code_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_code_failed(inputs)
	return en_password_reset_code_failed(inputs)
});